<template>
  <div>
    <!-- TODO 权限 -->
    <PageAllow
      controller="Quotations"
      :action="isNew ? 'add' : isView ? 'view' : mode"
    />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{
                $t(isNew ? "CRUD.newInfo" : "CRUD.info", [
                  $t("Question.ObjectName"),
                ])
              }}
              <v-chip
                v-if="!isNew"
                small
                label
                class="ms-4 mt-1"
                :color="
                  quotation.question_flg == 1 || quotation.cancel_flg == 1
                    ? 'danger'
                    : 'primary'
                "
                :text-color="quotation.status | questionFlgsTextColor"
              >
                <span
                  v-if="
                    quotation.question_flg == 0 && quotation.cancel_flg == 0
                  "
                >
                  {{ quotation.status | questionFlgsText }}
                </span>
                <span
                  v-if="
                    quotation.question_flg == 0 && quotation.cancel_flg == 1
                  "
                >
                  {{ quotation.cancel_flg | cancelFlgsText }}
                  {{ "(" }}{{ quotation.status | questionFlgsText }}{{ ")" }}
                </span>

                <span
                  v-if="
                    quotation.question_flg == 1 && quotation.cancel_flg == 0
                  "
                >
                  {{ quotation.status | questionFlgsText }}
                  {{ "(" }}{{ quotation.question_flg | questionDoubtFlgsText
                  }}{{ ")" }}
                </span>
                <span
                  v-if="
                    quotation.question_flg == 1 && quotation.cancel_flg == 1
                  "
                >
                  {{ quotation.cancel_flg | cancelFlgsText }}
                  {{ "【" }}
                  {{ quotation.status | questionFlgsText }}
                  {{ "(" }}{{ quotation.question_flg | questionDoubtFlgsText
                  }}{{ ")" }}
                  {{ "】" }}
                </span>
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <!-- 返回查看 -->
                <v-btn
                  v-if="!isNew && savable && !preview"
                  small
                  dark
                  outlined
                  color="secondary"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="mode = 'view'"
                >
                  <!-- <v-icon x-small class="pe-1">fa-times</v-icon> -->
                  {{ $t("CRUD.backToView") }}
                </v-btn>
                <!-- 返回修改 -->
                <v-btn
                  v-if="preview"
                  small
                  dark
                  outlined
                  color="secondary"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="
                    quotation_details = JSON.parse(beforPreview);
                    preview = false;
                  "
                >
                  <v-icon x-small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backForModify") }}
                </v-btn>
                <!-- 提交 -->
                <v-btn
                  v-if="
                    isNew && $permission.permissionAllow('Quotations', 'add')
                  "
                  small
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="preview ? doSubmit() : doPreview()"
                >
                  <!-- <v-icon x-small class="pe-1">fa-save</v-icon> -->
                  {{ $t("Question.actions.submit") }}
                </v-btn>
                <!-- 保存编辑 -->
                <v-btn
                  v-if="
                    mode == 'edit' &&
                    quotation.actions &&
                    quotation.actions.edit &&
                    $permission.permissionAllow('Quotations', 'edit')
                  "
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="preview ? doSubmit() : doPreview()"
                >
                  <!-- <v-icon x-small class="pe-1">fa-save</v-icon> -->
                  {{ $t("Question.actions.save_edit") }}
                </v-btn>
              </v-sheet>
              <!-- 导出 -->
              <v-btn
                v-if="isView"
                small
                dark
                color="action"
                class="px-2 me-2"
                @click.stop="Export(quotation.id)"
              >
                <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                {{ $t("Question.export") }}
              </v-btn>
              <v-btn
                small
                v-if="isView && quotation.actions && quotation.actions.edit"
                dark
                color="info"
                class="px-2 me-2"
                @click.stop="$router.push('/question/' + editId + '/edit')"
              >
                <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                {{ $t("Question.modify") }}
              </v-btn>
            </v-card-title>
          </v-expansion-panel-header>
          <v-divider />
          <v-expansion-panel-content>
            <v-row no-gutters class="mt-4 table-style">
              <!-- !isNew = 明细  编辑 -->
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Question.Fields.quotation_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ quotation.quotation_code }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Question.Fields.created") }}{{ $t("Global.colon") }}
                  </span>
                  {{ quotation.created | formatTime }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Question.Fields.creater") }}{{ $t("Global.colon") }}
                  </span>
                  {{ accountUserName }}
                </v-card>
              </v-col>
              <v-col cols="12" :md="isNew ? 4 : 12">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{
                      $t("Question.Fields.customer_name", [$consts.shopName()])
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ accountName }}
                </v-card>
              </v-col>
              <!-- 新建 创建时间 -->
              <v-col cols="12" md="4" v-if="isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Question.Fields.created") }}{{ $t("Global.colon") }}
                  </span>
                  {{ date }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Question.Fields.creater") }}{{ $t("Global.colon") }}
                  </span>
                  {{ creater }}
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- 活动记录 -->
        <v-expansion-panel v-if="!isNew">
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                @click.stop="
                  tab = 0;
                  panels.find((p) => p == 1) ? null : panels.push(1);
                "
              >
                {{ $t("Question.actions.activities") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="order_activities"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <!-- <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template> -->
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- 报价单明细 -->
      <v-card class="px-4 mt-4" v-resize="editDetailModeOnResize">
        <v-toolbar flat class="transparent-background-color">
          <v-row no-gutters align="center">
            <v-toolbar-title class="ms-n2">
              {{ $t("CRUD.details", [$t("Question.ObjectName")]) }}
            </v-toolbar-title>
            <v-spacer />
            <v-btn
              v-if="savable"
              small
              color="print"
              dark
              @click.stop="ImportDialog = true"
              class="ms-1 float-end"
            >
              <v-icon x-small class="pe-1">fa-file-import</v-icon>
              {{ $t("Question.Import") }}
            </v-btn>
            <v-btn-toggle
              v-if="savable && edit_details_mode_enable"
              v-model="edit_details_mode"
              dense
              mandatory
              color="primary"
              class="ms-4"
            >
              <v-btn small>{{ $t("Question.editDetailsMode.bySearch") }}</v-btn>
              <v-btn small>
                {{ $t("Question.editDetailsMode.byCategories") }}
              </v-btn>
            </v-btn-toggle>
          </v-row>
        </v-toolbar>
        <v-divider />
        <!-- 表格 -->
        <ValidationObserver ref="observer">
          <!-- 搜索  !savable --- 新增或编辑 -->
          <v-data-table
            v-show="!savable || edit_details_mode == 0"
            id="quotation_details_table"
            :headers="detailsHeaders"
            :items="quotationDetails"
            :search="filter"
            multi-sort
            disable-pagination
            hide-default-footer
            :no-data-text="$t('Question.DetailNoData')"
            class="pb-2"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <v-row no-gutters class="me-n3">
                  <span class="caption secondary--text pt-2">
                    {{
                      $t(
                        "$vuetify.dataFooter.pageText",
                        quotation_details
                          ? [
                              quotation_details.length > 0 ? 1 : 0,
                              quotation_details.length,
                              quotation_details.length,
                            ]
                          : [0, 0, 0]
                      )
                    }}
                  </span>
                  <v-row no-gutters>
                    <v-spacer />
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="filter"
                        clearable
                        hide-details
                        :label="$t('Search.filter')"
                      />
                    </v-col>
                  </v-row>
                </v-row>
              </v-toolbar>
            </template>

            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <!-- <v-icon x-small>fa-sliders-h</v-icon> -->
            </template>

            <!-- 搜索框 -->
            <template v-slot:footer>
              <v-row
                v-if="savable"
                no-gutters
                align="center"
                class="ps-1 text-no-wrap d-flex"
              >
                <span v-if="edit_details_mode == 0" class="secondary--text">
                  {{ $t("CRUD.newInfo", [$t("Material.ObjectName")])
                  }}{{ $t("Global.colon") }}
                </span>
                <keep-alive>
                  <SearcherQuotationsMaterial
                    v-if="edit_details_mode == 0"
                    v-model="addMaterial"
                    :disabled-items="
                      quotation_details
                        ? quotation_details.map((e) => {
                            return { material_id: e.material_id };
                          })
                        : []
                    "
                    no-label
                    show-price
                    @loaded="materials = $event"
                  />
                </keep-alive>
              </v-row>
            </template>
            <!-- quotation_details.splice(
                    quotation_details.findIndex((e) =>
                      item.id
                        ? item.id == e.material_id
                        : item.material_id == e.material_id
                    ),
                    1
                  ) -->
            <!-- 删除x -->
            <template v-slot:item.actions="{ item }">
              <v-btn
                v-if="item.new || detailEdit"
                small
                text
                class="danger--text pa-0"
                @click.stop="
                  quotation_details.splice(
                    quotation_details.findIndex((e) =>
                      item.material_id
                        ? item.material_id == e.material_id
                        : item.material_id == e.material_id
                    ),
                    1
                  )
                "
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
            </template>
            <!-- 上次供货价 -->
            <template v-slot:item.old_supply_price="{ item }">
              <a @click.stop="
                currentDetail = item;
                lineChartMaterialName = $t(
                  settings
                    ? settings.material_name_display_type == 3
                      ? 'Material.materialNameWithCodeAndStandard'
                        : settings.material_name_display_type == 2
                        ? 'Material.materialNameWithCode'
                      : 'Material.materialName'
                    : 'Material.materialName',
                  [item.material_code, item.material_name, item.standard_name]
                );
                echartsDialog = true;">
                {{ $t("Global.money") }}
                {{ item.old_supply_price ? item.old_supply_price : item.supply_price | formatMoney }}
              </a>
            </template>
            <!-- 是否采用 -->
            <template v-slot:item.use_flg="{ item }">
              <span v-if="item.use_flg == 0" style="color: red">
                {{ item.use_flg | useFlgsText }}
              </span>
              <span v-else>
                {{ item.use_flg | useFlgsText }}
              </span>
              <span> </span>
            </template>
            <!-- 报价 -->
            <template v-slot:item.new_supply_price="{ item }">
              <!-- <ValidationProvider
                v-slot="{ errors }"
                :name="$t('Question.questionDetail.Fields.quoted_price')"
                rules="required"
              > -->
              <v-text-field
                v-if="savable"
                v-model="item.new_supply_price"
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.new_supply_price
                    ? (item.new_supply_price =
                        $numberFormatter.formatWithDotNoMoreThan(
                          item.new_supply_price,
                          2
                        ))
                    : ''
                "
                @input="updateItemPrice()"
                style="max-width: 80px; margin-left: auto"
              >
              </v-text-field>

              <span v-else>
                {{ $t("Global.money")
                }}{{ item.new_supply_price | formatMoney }}
              </span>
              <!-- </ValidationProvider> -->
            </template>
          </v-data-table>
        </ValidationObserver>
        <!-- 分类 -->
        <keep-alive>
          <CardMaterials
            v-if="savable && edit_details_mode == 1"
            class="hidden-print pb-2"
            v-model="quotationDetails"
            :mode="mode"
            @add="addQuotationsDetail($event.material, $event.num)"
            @update="updateItemPrice($event.material)"
          />
        </keep-alive>
      </v-card>
    </v-sheet>
    <ImportExcelAlert
      v-model="ImportDialog"
      :objName="$t('Question.ObjectName')"
      :supplier_id ="accountUser.supplier_id"
      @import="
        excelFile = $event;
        importExcel();
      "
    />

    <DialogEconomyHistoryEcharts
      v-model="echartsDialog"
      :supplierId="accountUser.supplier_id"
      :currentDetail="currentDetail"
      :lineChartMaterialName="lineChartMaterialName"
      @close="echartsDialog = false"
    />
  </div>
</template>


<script>
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Quotations from "@/api/quotations";
import SearcherQuotationsMaterial from "@/components/plugins/SearcherQuotationsMaterial";
import ImportExcelAlert from "./plugins/ImportExcelAlert";
import CardMaterials from "./plugins/CardMaterials";
import snackbar from "@/plugins/snackbar";
import DialogEconomyHistoryEcharts from "@/components/plugins/DialogEconomyHistoryEcharts"
import { mapState } from "vuex";

import { ValidationObserver } from "vee-validate";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    ValidationObserver,
    // ValidationProvider,
    SearcherQuotationsMaterial,
    ImportExcelAlert,
    CardMaterials,
    DialogEconomyHistoryEcharts,
  },

  computed: {
    // eslint-disable-next-line vue/return-in-computed-property

    editId() {
      return this.$route.params.id;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    creater() {
      if (this.accountUser) {
        return this.accountUser.name;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    date() {
      var dayjs = require("dayjs");
      return dayjs().format("YYYY-MM-DD HH:mm");
    },
    // eslint-disable-next-line vue/return-in-computed-property
    accountUserName() {
      if (this.accountUser) {
        return this.accountUser.supplier.supplier_name;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    accountName() {
      if (this.accountInfo) {
        return this.accountInfo.account_name;
      }
    },

    isView() {
      return !this.mode || this.mode == "view" || this.mode == "approve";
    },
    savable() {
      return (
        !this.preview &&
        (this.mode == "new" || this.mode == "edit" || this.mode == "confirm")
      );
    },
    isNew() {
      return this.mode == "new";
    },

    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.question"),
          disabled: false,
          href: "/question",
        },
        {
          text: this.isNew
            ? i18n.t("Nav.questionNew")
            : i18n.t("Nav.questionDetail"),
          disabled: true,
        },
      ];
      if (!this.isNew && this.quotations && this.quotations.purchase_code) {
        items.push({
          text: this.quotations.purchase_code,
          disabled: false,
          accent: true,
        });
      }
      return items;
    },

    activitiesHeaders: () => [
      {
        text: i18n.t("Question.Fields.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("Question.Fields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("Question.Fields.operater_name"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],

    detailEdit() {
      return this.isView == true || this.mode == "edit";
    },

    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("Question.questionDetail.Fields.category"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("Question.questionDetail.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("Question.questionDetail.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("Question.questionDetail.Fields.standards"),
          align: "start",
          sortable: false,
          value: "standard_name",
        },
        {
          text: i18n.t("Question.questionDetail.Fields.unit"),
          align: "start",
          sortable: false,
          value: "unit",
        },
        {
          text: i18n.t("Question.questionDetail.Fields.supply_price"),
          align: "end",
          sortable: false,
          value: "old_supply_price",
        },
      ];
      if (this.detailEdit) {
        headers.push(
          {
            text: i18n.t("Question.questionDetail.Fields.quoted_price"),
            align: "end",
            sortable: false,
            value: "new_supply_price",
          },
          {
            text: i18n.t("Question.questionDetail.Fields.use_flg"),
            align: "center",
            sortable: false,
            value: "use_flg",
          },
          {
            text: i18n.t("Question.questionDetail.Fields.memo"),
            align: "start",
            sortable: false,
            value: "memo",
          }
        );
      } else {
        headers.push(
          {
            text: i18n.t("Question.questionDetail.Fields.quoted_price"),
            align: "end",
            sortable: false,
            value: "new_supply_price",
          }
          // {
          //   text: i18n.t("Question.questionDetail.Fields.memo"),
          //   align: "start",
          //   sortable: false,
          //   value: "memo",
          // }
        );
      }

      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    ...mapState(["accountInfo", "accountUser", "settings"]),

    quotationDetails() {
      return this.quotation_details;
    },
  },
  data: () => ({
    mode: "",
    preview: false,
    panels: [0],
    quotation: {},
    beforPreview: [],
    tab: null,
    order_activities: [],
    edit_details_mode_enable: true,
    edit_details_mode: 0, // 0搜索、1全部、2……尚无
    quotation_details: [],
    filter: "",
    addMaterial: null,
    // serverErrors: [],
    error: false,
    ImportDialog: false,
    echartsDialog: false,
    currentDetail: null,
    lineChartMaterialName: "",
  }),

  watch: {
    $route(to) {
      if (to.path.startsWith("/question/new")) {
        this.mode = "new";
        // 重新初始化界面
        // this.serverErrors = [];
        this.panels = [0];
        this.tab = null;
        this.quotation = {};
        this.quotation_details = [];
        this.filter = "";
        this.addMaterial = null;
      } else if (to.params.mode) {
        this.mode = to.params.mode;
        this.$router.replace("/question/" + to.params.id);
      }
    },
    mode: {
      handler() {
        if (this.$route.params.id) {
          this.getQuotationsFromAPI();
        }
      },
    },
    edit_details_mode: {
      handler() {
        localStorage.setItem(
          "quotations_new_details_mode",
          this.edit_details_mode
        );
      },
    },

    quotation: {
      handler() {
        this.quotation_details =
          this.quotation && this.quotation.quotation_details
            ? this.quotation.quotation_details
            : [];
      },
    },

    addMaterial: {
      handler() {
        if (this.addMaterial && this.addMaterial.material_id) {
          this.addQuotationsDetail(this.addMaterial);
          this.addMaterial = {
            material_id: 0,
            material_code: "",
            material_name: "",
            standard_name: "",
          }; //消除显示
        }
      },
    },
    quotation_details: {
      deep: true,
      handler() {
        // console.log(this.quotation_details);
      },
    },
  },

  mounted() {
    // console.log(this);
    if (this.$route.path.startsWith("/question/new")) {
      this.mode = "new";
    } else {
      this.mode = this.$route.params.mode;
      if (this.mode) this.$router.replace("/question/" + this.$route.params.id);
    }

    if (localStorage.getItem("quotations_new_details_mode"))
      this.edit_details_mode = Number(
        localStorage.getItem("quotations_new_details_mode")
      );
  },

  methods: {
    editDetailModeOnResize() {
      if (window.innerWidth < 600) {
        this.edit_details_mode = 0;
        this.edit_details_mode_enable = false;
      } else {
        this.edit_details_mode_enable = true;
      }
    },

    previewMethod() {
      this.data = {
        quotation_details: this.quotation_details,
      };
      if (this.isNew) return Quotations.addPreview(this.data);
      else if (this.mode == "edit") return Quotations.editPreview(this.data);
    },
    // 确认
    submitMethod() {
      if (this.isNew) return Quotations.add(this.data);
      else if (this.mode == "edit")
        return Quotations.edit(this.$route.params.id, this.data);
    },
    // 进入预览
    doPreview() {
      // 1 分类 0 搜索
      if (this.edit_details_mode == 1) {
        this.beforPreview = JSON.stringify(this.quotation_details);
        this.$refs.observer.validate().then(
          function (result) {
            if (result) {
              this.previewMethod().then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.preview = true;
                    this.quotation_details = response.data.quotation_details;
                  }
                }.bind(this)
              );
            } else {
              this.$scrollIntoView("quotation_details_table");
            }
          }.bind(this)
        );
      }
      var error = false;
      // console.log(this);
      for (var i = 0; i < this.quotation_details.length; i++) {
        if (
          this.quotation_details[i].new_supply_price == null ||
          this.quotation_details[i].new_supply_price == undefined ||
          this.quotation_details[i].new_supply_price == ""
        ) {
          error = true;
          break;
        } else {
          error = false;
        }
      }
      if (error && this.edit_details_mode == 0) {
        this.$snackbar.error(i18n.t("Question.Messages.error"));
      } else {
        // this.serverErrors = [];
        this.beforPreview = JSON.stringify(this.quotation_details);
        this.$refs.observer.validate().then(
          function (result) {
            if (result) {
              this.previewMethod().then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.preview = true;
                    this.quotation_details = response.data.quotation_details;
                  }
                }.bind(this)
              );
            } else {
              this.$scrollIntoView("quotation_details_table");
            }
          }.bind(this)
        );
      }
    },
    doSubmit() {
      this.submitMethod().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.push("/question");
          } else if (response.data.error.code == "ERR759") {
            this.preview = false;
            this.mode = "view";
          }
        }.bind(this)
      );
    },

    getQuotationsFromAPI() {
      Quotations.fetchOne(this.$route.params.id, { order_activity: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.quotation = response.data.quotation;
            this.order_activities = response.data.order_activities;
          }
        }.bind(this)
      );
    },

    addQuotationsDetail(material, num) {
      if (num < 0) return;
      var quotation_detail = {
        new: true,
        material_id: material.material_id,
        category_name: material.material.material_category.name,
        material_code: material.material.material_code,
        material_name: material.material.material_name,
        standard_name: material.standard.name,
        unit: material.standard_detail.unit,
        old_supply_price: material.supply_price,
        memo: material.memo,
        new_supply_price: num,
        use_flg: 0,
      };
      this.quotation_details.push(quotation_detail);
      this.updateItemPrice(material);
    },
    updateItemPrice() {},
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      Quotations.imports(this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              snackbar.info(i18n.t("Import.success", [i18n.t("Question.ObjectName")]));
              this.ImportDialog = false;
              response.data.materials.forEach((material) => {
                if ( this.quotation_details.find((details) => {
                  return material.material_code == details.material_code;
                })) {
                  this.quotation_details[this.quotation_details.findIndex((detail) => material.material_code == detail.material_code)].new_supply_price = material.new_supply_price
                } else {
                  this.quotation_details.push(material)
                }
              });
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        ).catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
      );
    },
  },
};
</script>

<style>
</style>